import * as React from 'react';
import * as classNames from 'classnames';
import keyBy = require('lodash/keyBy');
import {Input} from '../../input/input';
import {TextArea} from '../../textarea/textarea';
import {Form, IFormComponentProps} from '../../form/form';
import {MAX_LENGTH_JOB_DESCRIPTION} from '../../../utils/validator';
import {IJobsFormData} from '../../../redux/modules/jobs/reducer';
import {JobsCharacterCounter as CharacterCounter} from '../character-counter';
import './styles.sass';

interface IJobsApplyFormProps extends IFormComponentProps {
  isLoading: boolean;
  formSubmit: (params: IJobsFormData) => void;
}

const PREFIX = 'jobs-apply-form';

class JobsApplyForm extends React.PureComponent<IJobsApplyFormProps> {
  public render(): React.ReactElement<any> {
    const {onChangeFormField, fields, fieldNameWithFirstError, isLoading} = this.props;
    const {jobUsername, jobEmail, jobDescription} = keyBy(fields, 'fieldName');
    return (
      <div className={PREFIX}>
        <div className={`${PREFIX}__title`}>Apply</div>
        <div className={`${PREFIX}__row`}>
          <Input
            fontWeightNormal
            placeholder={'Your name'}
            error={jobUsername.error}
            className={`${PREFIX}__firstname`}
            focused={fieldNameWithFirstError === jobUsername.fieldName}
            onChange={(value: string) => onChangeFormField(jobUsername.fieldName, value)}
          />
          <Input
            fontWeightNormal
            placeholder={'Email'}
            error={jobEmail.error}
            className={`${PREFIX}__email`}
            focused={fieldNameWithFirstError === jobEmail.fieldName}
            onChange={(value: string) => onChangeFormField(jobEmail.fieldName, value)}
          />
        </div>
        <div className={`${PREFIX}__description`}>
          <TextArea
            rows={8}
            defaultValue={''}
            onChange={this.onChangeDescription}
            error={jobDescription.error}
            focused={fieldNameWithFirstError === jobDescription.fieldName}
            placeholder={'Please share a short description of what excites you about this position, ' +
            'as well as why you\'re the right person for it. Keep it short, 1-2 paragraphs'}
          />
          <CharacterCounter
            textLength={jobDescription.value.length}
            maxLength={MAX_LENGTH_JOB_DESCRIPTION}
          />
        </div>
        <div className={`${PREFIX}__button-container`}>
          <button
            className={classNames('btn btn_lg btn_genoa-viridian',
              `${PREFIX}__button`,
              {
                [`${PREFIX}__button_loading`]: isLoading,
              },
            )}
            onClick={this.onFormSubmit}
          >
            {isLoading ? 'Loading...' : 'Submit'}
          </button>
        </div>
      </div>
    );
  }

  private onChangeDescription = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
    const {fields, onChangeFormField} = this.props;
    const {jobDescription} = keyBy(fields, 'fieldName');
    const target: HTMLTextAreaElement = event.target;
    onChangeFormField(jobDescription.fieldName, target.value);
  };

  private onFormSubmit = (): void => {
    const {isFormValid, fields, formSubmit} = this.props;
    const {jobUsername, jobEmail, jobDescription} = keyBy(fields, 'fieldName');
    isFormValid()
    && formSubmit({
      jobUsername: jobUsername.value,
      jobEmail: jobEmail.value,
      jobDescription: jobDescription.value,
    });
  }
}

export const JobsApplyFormContainer =  Form(JobsApplyForm);
